<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">{{ lang.label }} Section</h5>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="title"
                rules=""
                name="The Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="title"
                          name="title"
                          fou
                          v-model="formData.title">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="language"
                rules=""
                name="The Language"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Language"
                          name="language"
                          fou
                          v-model="formData.language">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="Location"
                rules=""
                name="The Location"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="location"
                          name="location"
                          fou
                          v-model="formData.location">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group">
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <div class="col-md-12">
            <div class="">
              <label>Agenda</label>
              <div class="col-12">
                <template class="row" v-for="(item, itemIndex) in formData.agendas">
                  <div class="col-md-12">
                    <fg-input type="text"
                              :key="itemIndex"
                              :label="'Agenda '+(itemIndex+1)"
                              v-model="formData.agendas[itemIndex].title">
                    </fg-input>
                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeWriter(formData.agendas, itemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewWriter(formData.agendas, {title: ''})"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </form>
  </ValidationObserver>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import { extend } from "vee-validate";
  import { required, email, regex } from "vee-validate/dist/rules";
  import Editor from '@tinymce/tinymce-vue'
  import FormGroupTextArea from "@/components";
  import MultipleFileUploaderFileManager from "../../../components/FileManager/MultipleFileUploaderFileManager";

  extend("required", required);
  extend("email", email);
  extend("regex", regex);

  export default {
    components: {
      FormGroupTextArea,
      [Select.name]: Select,
      [Option.name]: Option,
      'editor': Editor,
      MultipleFileUploaderFileManager
    },
    props: {
      lang: {
        type: Object
      },
      editMode: {
        type: Boolean,
        default: false
      },
      isSubmit: {
        type: Boolean,
        default: false
      },
      formData:{
        type: Object,
        default() {
          return {
            title: "",
            url: "",
            content: "",
            registration_link: '',
            language: '',
            agendas: [],
          }
        }
      },
    },
    data () {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
        imagesExtensions: this.getImagesExtensions(),
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang.value, this.isSubmit)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      addNewWriter(writers, listObject){
        writers.push(listObject);
      },
      removeWriter(writers, index) {
        writers.splice(index, 1);
      },
    }
  }
</script>
<style>
</style>
